import * as signalR from "@microsoft/signalr";

$(document).ready(function () {    
    try {
        const connection = new signalR.HubConnectionBuilder()
            .withUrl("/notificationshub")
            .build();

        const divMessages: HTMLDivElement = document.querySelector("#dbh_message");
        const divWrapper: HTMLDivElement = document.querySelector("#dbh_notificationWrapper");
        const btnSend: HTMLButtonElement = document.querySelector("#btnSend");
        const txtNachricht: HTMLTextAreaElement = document.querySelector("#txtNachricht");

        connection.on("ReceiveMessage", (message: string) => {            
            let m = document.createElement("div");

            m.innerHTML = `<div>${message}</div>`;

            divMessages.appendChild(m);
            divMessages.scrollTop = divMessages.scrollHeight;
            
            $(divWrapper).fadeIn();
            window.setTimeout(function () {
                $(divWrapper).fadeOut();
            }, 6000);
        });

        connection.start().catch(err => console.log(err));

        btnSend.addEventListener("click", function () {
            send($(txtNachricht).val() as string);
        });

        function send(text: string) {
            connection.send("NewMessage", text);
        }
    } catch (e) {
        console.log(e.message);
    }
});
